import React from "react";

const Schedule = () => {
  // Array of schedules
  const schedules = [
    { name: "NextGen Robotics With AI and NodeMCU", file: "/nextgen.pdf" },
    { name: "Autodesk Fusion 360 With 3D Printing", file: "/autodesk.pdf" },
    { name: "Technical Events", file: "/technical-events.pdf" },
  ];

  return (
    <div className="p-6 my-6 rounded-2xl shadow-md bg-white">
      <h2 className="text-2xl font-bold text-center mb-6 bg-gradient-to-r from-purple-500 to-pink-500 text-white py-3 rounded-lg">
        Event Schedules
      </h2>

      <div className="grid md:grid-cols-3 gap-6">
        {schedules.map((schedule, index) => (
          <div
            key={index}
            className="rounded-xl shadow-lg p-4 border bg-gradient-to-br from-purple-50 to-pink-50"
          >
            <h3 className="text-lg font-semibold text-center mb-3">
              {schedule.name}
            </h3>

            {/* View PDF inside iframe */}
            <iframe
  src={schedule.file}
  width="100%"
  height="300px"
  className="rounded-lg shadow-md border-0" // ✅ removes border
  style={{ border: "none" }}                // ✅ extra safety
  title={`${schedule.name} Schedule`}
/>


            {/* Download Button */}
            <div className="text-center mt-3">
              <a
                href={schedule.file}
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 rounded-lg text-white font-medium bg-gradient-to-r from-purple-500 to-pink-500 hover:opacity-90"
              >
                Download
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* Extra Events Below PDFs */}
      <div className="mt-8 text-center">
        <p className="text-lg font-semibold text-purple-900">
          🎉 Flashmob at 5:00 PM
        </p>
        <p className="text-lg font-semibold text-pink-900">
          🎶 Culturals at 6:00 PM
        </p>
      </div>
    </div>
  );
};

export default Schedule;
